<template>
	<div class="db2-wo">
		<div class="db2-wo-head">
			<div class="db2-wo-heading">
				<v-icon v-if="isEditMode" small class="db2-card-drag" @mousedown.native.stop="onDragStart">mdi-drag</v-icon>
				<span>{{ card.name }}</span>
			</div>
			<a class="db2-card-link" href="#">View all ({{ rows.length }}) →</a>
		</div>
		<div class="db2-wo-list">
			<div class="db2-wo-item" v-for="row in rows" :key="row.id">
				<div class="db2-wo-top">
					<div class="id">{{ row.id }}</div>
					<div class="db2-wo-badges">
						<span class="prio" :class="'is-' + row.priority.toLowerCase()">{{ row.priority }}</span>
						<span class="when">{{ row.age }}</span>
					</div>
				</div>
				<div class="title">{{ row.title }}</div>
				<div class="place" v-if="row.place">{{ row.place }}</div>
				<div class="who">
					<span class="avatar">{{ initials(row.assignee) }}</span>
					<span>Assigned to: {{ row.assignee }}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mockWorkOrders } from '../mockPointData';

/**
 * Initials from a person name.
 * @param {string} name
 * @returns {string}
 */
function initialsFrom(name) {
	return String(name || '')
		.split(/\s+/)
		.filter(Boolean)
		.slice(0, 2)
		.map(p => p.charAt(0).toUpperCase())
		.join('') || '?';
}

/**
 * Mock work-order list styled like Urgent Tickets.
 */
export default {
	name: 'WorkOrdersCard',
	props: {
		card: { type: Object, required: true },
		isEditMode: { type: Boolean, default: false },
		timePeriod: { type: String, default: 'week' }
	},
	computed: {
		/**
		 * Rows.
		 * @returns {Array}
		 */
		rows() {
			return mockWorkOrders(this.card.uniqueId);
		}
	},
	methods: {
		/**
		 * Start a canvas move from the in-card title handle.
		 * @param {MouseEvent} e
		 */
		onDragStart(e) {
			if (!this.isEditMode) return;
			this.$emit('drag-start', e);
		},
		/**
		 * Avatar letters.
		 * @param {string} name
		 * @returns {string}
		 */
		initials(name) {
			return initialsFrom(name);
		}
	}
};
</script>
